import React, { useEffect } from 'react'
import Contact from '../../Utilitis/Contact/Contact'
import SingalHeader from '../../Utilitis/SingalHeader'
import { motion } from 'framer-motion';

export default function ContactPage() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        < >
            <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ duration: 0.3 }}
            >
                <SingalHeader title="Contact As" />
                <Contact noTitle />
            </motion.div>
        </>
    )
}
